import axios from "axios";
import moment from "moment";
import { ip_back } from "../../../config";
import { formatDate, getDurationTS } from "../dataFormat";

//import { getMyTraining as getMyTrainingM } from "../../mock/home/MockMyTraining";

import training1 from "../../assets/training1.jpg"
import training2 from "../../assets/training2.jpg"

const imgs = [training1, training2];

const adaptTraining = async (data) => {
    var adaptedData = []

    console.log("🔍 adaptTraining - Input data length:", data?.length);
    if (data && data.length > 0) {
        console.log("🔍 adaptTraining - First item sample:", {
            ts_id: data[0].ts_id,
            ts_date: data[0].ts_date,
            ts_start_time: data[0].ts_start_time,
            time_id: data[0].time_id,
            ts_session_number: data[0].ts_session_number,
            tbl_state_te: data[0].tbl_state_te,
            allKeys: Object.keys(data[0]),
        });
    }

    for (let i = 0; i < data.length; i++) {
        const ts = data[i];
        
        // Use ts_start_time if available, otherwise fallback to time_id or empty string
        const timeStr = ts.ts_start_time || ts.time_id || "";
        // ts.ts_date might be a Date object, string, or moment - format it properly
        let dateStr = null;
        if (ts.ts_date) {
            if (ts.ts_date instanceof Date) {
                dateStr = moment(ts.ts_date).format("YYYY-MM-DD");
            } else if (moment.isMoment(ts.ts_date)) {
                dateStr = ts.ts_date.format("YYYY-MM-DD");
            } else {
                // Try to parse as string
                const parsed = moment(ts.ts_date);
                if (parsed.isValid()) {
                    dateStr = parsed.format("YYYY-MM-DD");
                } else {
                    dateStr = ts.ts_date; // Use as-is if parsing fails
                }
            }
        }
        
        const dateTimeStr = dateStr ? (dateStr + (timeStr ? " " + timeStr : "")) : null;
        
        adaptedData.push({
            id: ts.ts_id,
            name: ts.ts_session_number
              ? (ts.ts_owner_player_id
                  ? `Session #P${String(ts.ts_session_number).padStart(3, "0")}`
                  : `Session #${ts.ts_session_number}`)
              : ("Session " + ts.ts_id.substring(0, 8)),
            heading: "Heading " + ts.ts_id.substring(0, 16),
            image: imgs[i % 2],
            datetime: dateTimeStr ? await formatDate(dateTimeStr) : null,
            datetimeRaw: dateTimeStr, // Keep raw datetime for comparison
            ts_date: ts.ts_date, // Keep raw date (might be Date object, string, or moment)
            ts_start_time: ts.ts_start_time, // Keep raw time for comparison
            state: ts.tbl_state_te?.st_id === "st202406071447279903" ? "finalized" : 
                   ts.tbl_state_te?.st_id === "st202406071447279901" ? "running" : 
                   ts.tbl_state_te?.st_id === "st202406071447279902" ? "paused" : "scheduled",
            duration: await getDurationTS(ts.tbl_training_exercises || []),
        },)
    }
    
    console.log("✅ adaptTraining - Adapted data length:", adaptedData.length);
    return adaptedData;
}

export const getMyTraining = async (token) => {
    console.log("🚀 getMyTraining - Function called");
    //var rpta_mock = await getMyTrainingM(token);

    //use API
    // Normalize URL to avoid double slashes
    const baseUrl = ip_back.endsWith('/') ? ip_back.slice(0, -1) : ip_back;
    const apiPath = '/api/training/getTrainingSessionList';
    const fullUrl = baseUrl + apiPath;
    
    console.log("🔍 getMyTraining - URL components:", { ip_back, baseUrl, apiPath, fullUrl });
    
    var config = {
        method: 'get',
        url: fullUrl,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        },
        timeout: 15000, // 15 second timeout for axios
    };

    var rpta = {
        status: 'error',
        message: 'Network error',
        data: null
    };

    console.log("🔍 getMyTraining - Making API call to:", fullUrl);
    console.log("🔍 getMyTraining - Config:", { method: config.method, url: config.url, hasToken: !!token });
    
    try {
        await axios(config)
        .then(async function (response) {
            console.log("✅ getMyTraining - API call successful, response:", response);
            rpta = response.data;
            console.log("🔍 getMyTraining - Response data:", rpta);

            if (rpta.data && Array.isArray(rpta.data)) {
                console.log("🔍 getMyTraining - Adapting", rpta.data.length, "sessions");
                const adaptedData = await adaptTraining(rpta.data);
                //rpta.data = [...adaptedData, ...rpta_mock.data];
                rpta.data = [...adaptedData];
                console.log("✅ getMyTraining - Adapted", adaptedData.length, "sessions");
            } else {
                console.warn("⚠️ getMyTraining - No data array in response:", rpta);
                rpta.data = [];
            }
        })
    } catch (error) {
        console.error("❌ getMyTraining - API call failed:", error);
        console.error("❌ getMyTraining - Error details:", {
            message: error.message,
            code: error.code,
            response: error.response?.data,
            status: error.response?.status,
            url: fullUrl,
        });
        rpta.status = 'error';
        rpta.message = error.response?.data?.message || error.message || 'Network error';
        rpta.data = null;
    }

    console.log("🔍 getMyTraining - Returning:", { status: rpta.status, dataLength: rpta.data?.length });
    return rpta;
};